<template>
  <div class="busca">
    <div class="linha-busca">
      <input
        type="text"
        placeholder="Pesquise por nome, marca, plano de aparelho ou SKU"
        ref="searchInput"
        :value="finderText"
        @click="verifyData"
        @keyup="inicarBusca"
        @keyup.esc="clearText"
      />
      <button v-if="!!finderText" class="botao-busca">BUSCAR</button>
      <img src="@/assets/vivo-consulta/icones/icone-busca.svg" v-else class="icone-botao" />

      <div
        class="opcoes"
        v-if="visible"
        v-outside="{
          exclude: ['searchInput'],
          handler: 'onClose',
        }"
      >
        <perfect-scrollbar :options="scrollOptions">
          <template v-if="data.length > 0">
            <ul>
              <a
                v-for="item in data"
                :key="item.id"
                @click="opcaoSelecionada(item.id, item.modelo)"
              >
                <li>{{ item.modelo }}</li>
              </a>
            </ul>
          </template>
          <template v-else>
            <ul>
              <li class="notfound">Nenhum aparelho foi localizado...</li>
            </ul>
          </template>
        </perfect-scrollbar>
      </div>
    </div>

    <div class="linha-filtros">
      <!-- <button :class="ativo ? 'ativo' : ''" @click="ativarFiltros"> -->
      <button class="btnFiltros" style="cursor: default !important">
        <img src="@/assets/vivo-consulta/icones/icone-filtro.svg" class="icone" />
        <span>Filtre sua busca</span>
        <img src="@/assets/vivo-consulta/imagens/borda-botao.svg" class="borda" />
      </button>
      <nav>
        <ul>
          <a
            v-for="(menu, indice) in filtrosMenu"
            :key="indice"
            href="javascript:void(0);"
            @click="setType(menu.type)"
          >
            <li :class="menu.type === finderType ? 'menu-ativo' : ''">
              <img :src="require(`@/assets/vivo-consulta/icones/${menu.icone}`)" />
              {{ menu.titulo }}
            </li>
          </a>
        </ul>
      </nav>
      <selecione-uf class="selectUF" />
    </div>

    <!-- <div class="filtros-avancados" v-if="ativo">
        <filtro-select :lista="itemsBusca" titulo="Tecnologia"/>
        <filtro-select :lista="itemsBusca" titulo="Fabricante"/>
        <filtro-select :lista="itemsBusca" titulo="Tamanho da Tela"/>
        <filtro-select :lista="itemsBusca" titulo="Tipo de Tela"/>
        <filtro-select :lista="itemsBusca" titulo="Memória Ram"/>
        <filtro-select :lista="itemsBusca" titulo="Memória Interna"/>
        <filtro-select :lista="itemsBusca" titulo="Memória Externa"/>
        <filtro-select :lista="itemsBusca" titulo="Sistema Operacional"/>
        <filtro-select :lista="itemsBusca" titulo="Processador"/>
        <filtro-select :lista="itemsBusca" titulo="Bateria"/>
        <filtro-select :lista="itemsBusca" titulo="Bluetooth"/>
        <filtro-select :lista="itemsBusca" titulo="Câmera Traseira"/>
        <filtro-select :lista="itemsBusca" titulo="Câmera Frontal"/>
    </div>-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import EventBus from '@/event-bus';
import SelecioneUF from '@/components/vivo-consulta/header/SelecioneUF.vue';
import outside from '@/directives/outside-click';
// import FiltroSelect from '@/components/vivo-consulta/header/FiltroSelect.vue';

export default {
  name: 'Busca',
  components: {
    'selecione-uf': SelecioneUF,
    PerfectScrollbar,
    // FiltroSelect,
  },
  directives: {
    outside,
  },
  data() {
    return {
      scrollOptions: {
        wheelSpeed: 0.4,
        wheelPropagation: true,
        minScrollbarLength: 20,
        maxScrollbarLength: 50,
      },
      filtrosMenu: [
        {
          icone: 'icone-filtro-smartphone.png',
          titulo: 'Smartphones',
          type: 'smartphone',
        },
        {
          icone: 'icone-filtro-headphone.png',
          type: 'acessorios',
          titulo: 'Acessórios',
        },
        // {
        //   icone: 'icone-filtro-fone.png',
        //   type: 'ftw',
        //   titulo: 'FTW',
        // },
        // {
        //   icone: 'icone-filtro-modem.png',
        //   type: 'pen_modem',
        //   titulo: 'Pen Modem',
        // },
        // {
        //   icone: 'icone-filtro-router.png',
        //   type: 'roteador',
        //   titulo: 'Roteador',
        // },
        // {
        //   icone: 'icone-filtro-netbook.png',
        //   type: 'netbook',
        //   titulo: 'Netbook',
        // },
      ],
    };
  },
  computed: {
    ...mapGetters({
      finderType: 'vcBusca/finderType',
      finderText: 'vcBusca/finderText',
      data: 'vcBusca/data',
      visible: 'vcBusca/visible',
    }),
  },
  methods: {
    ...mapActions({
      setType: 'vcBusca/setType',
      setText: 'vcBusca/setText',
      clearText: 'vcBusca/clearText',
      setVisible: 'vcBusca/setVisible',
      search: 'vcBusca/searchData',
      findExistsData: 'vcBusca/findData',
    }),
    verifyData() {
      this.findExistsData();
    },
    inicarBusca(event) {
      const { value } = event.target;
      this.setText(value);
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.search(value);
      }, 1000);
    },
    onClose() {
      this.setVisible(false);
    },
    ativarFiltros() {
      this.ativo = !this.ativo;
    },
    opcaoSelecionada(item, modelo) {
      this.setVisible(false);
      EventBus.$emit('tb-action', { modelo, action: 'search' });
      this.$router.push({
        name: 'vivo.consulta.page',
        params: {
          page: this.finderType,
          id: item,
        },
      });
    },
  },
};
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css" />
<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.busca {
  @extend %area-de-utilizacao;
  margin: 0 auto;
  position: relative;
  z-index: 99;

  & .linha-busca {
    display: flex;
    align-items: center;
    width: calc(100% - 40px);
    position: relative;
    margin-top: 20px;
    background: white;
    border-radius: 5px 5px 5px 0;
    height: 60px;
    padding: 0 20px;
    box-shadow: inset 0px 0px 10px rgba($cor_roxo, 0.5);

    & input {
      width: 90%;
      border: 0px;
      outline: none;
      font-family: 'OpenSans';
      font-size: 1vw;
      color: $cor_roxo;
      font-weight: 600;

      @media (max-width: 1024px) {
        font-size: 1.5vw;
      }

      @media (max-width: 650px) {
        font-size: 2.5vw;
      }

      @media (max-width: 450px) {
        font-size: 3.4vw;
      }
      &::placeholder {
        color: $cor_roxo;
        font-weight: normal;
      }
    }

    & .botao-busca {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 130px;
      height: 50px;
      border-radius: 2px;
      background: $cor_amarelo;
      color: $cor_roxo;
      font-family: 'VivoType';
      font-weight: bold;
      font-size: 16px;
      border: 0px;
      padding: 0px;
      margin: 0px;
      outline: none;
      animation: btn 0.6s linear;
      animation-iteration-count: 1;

      &:hover {
        background: $cor_roxo;
        color: $cor_amarelo;
      }
    }

    & .icone-botao {
      position: absolute;
      top: 18px;
      right: 20px;
      background: transparent;
      border: 0px;
      padding: 0px;
      margin: 0px;
      outline: none;
      animation: btn 1s linear;
      animation-iteration-count: 1;
    }

    & .opcoes {
      position: absolute;
      top: 57px;
      left: 0;
      width: 100%;
      z-index: 2;
      max-height: 350px;
      box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.5);

      & .ps {
        max-height: 350px;
      }

      & ul {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: calc(100% - 40px);
        padding: 20px 20px;
        margin: 0px;
        background: white;
        border-radius: 0 0 5px 5px;
        box-shadow: 0px 5px 20px rgba(black, 0.2);

        & .notfound {
          font-size: 13px;
          letter-spacing: 1.13px;
          color: #660099;
        }

        & a {
          color: $cor_cinza_dark;
          padding: 10px 20px;
          border-radius: 20px;
          transition: all 0.2s ease-in-out;

          &:hover {
            color: white;
            background: $cor_roxo;
          }

          &:active {
            color: $cor_roxo;
          }
        }
      }
    }
  }

  & .linha-filtros {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 20px;
    position: relative;
    @media (max-width: 650px) {
      background-color: #ee007b;
      line-height: 50px;
    }
    & .selectUF {
      position: absolute;
      right: 15px;
      bottom: 5px;
    }

    & button {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      position: relative;
      background: $cor_amarelo;
      border: 0px;
      width: 225px;
      height: 50px;
      outline: none;

      @media (max-width: 650px) {
        width: 100%;
      }

      & :active {
        filter: brightness(1.1);
      }

      & .icone {
        width: 26px;
        height: 26px;
        margin-right: 10px;
      }

      & span {
        font-size: 18px;
        font-family: 'VivoType';
        font-weight: bold;
        color: $cor_roxo;
        text-transform: uppercase;
        margin-right: -20px;
      }

      & .borda {
        position: absolute;
        top: 0;
        right: -37px;
        @media (max-width: 650px) {
          display: none;
        }
      }
    }

    & .ativo {
      box-shadow: 0px 5px 20px rgba($cor_amarelo, 0.5);
    }

    & nav {
      & ul {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        padding: 0px;
        margin: 0px;

        & a {
          color: white;
          text-decoration: none;
          font-size: 16px;
          font-family: 'VivoType';
          font-weight: bold;
          margin-right: 24px;
          transition: all 0.2s ease-in-out;
          &:first-child {
            margin-left: 50px;
            @media (max-width: 650px) {
              margin-left: 5px;
              margin-right: 5px;
            }
          }

          & li {
            display: flex;
            align-items: center;

            & img {
              margin-right: 7px;
            }
          }

          & .menu-ativo {
            color: $cor_amarelo;
          }

          &:hover {
            color: $cor_amarelo;
          }

          & :active {
            transform: scale(0.95);
          }
        }

        & a:last-child {
          margin-right: 0px;
        }
      }
    }
  }

  & .filtros-avancados {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 15px 0;
    flex: 1;
    animation: btn 0.6s linear;
    animation-iteration-count: 1;

    &::after {
      content: '';
      flex: 0 0 380px;
    }
  }
}

@keyframes btn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
